import { Typography, Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React from "react";
import ICoBrowseDto from "../../../../interface/ICoBrowseDto";
import { CoBrowseContext } from "../../../../store/coBrowse.context";

const CoBrowseStatus = (): React.JSX.Element => {
  const {
    coBrowseDto,
  }: {
    coBrowseDto: ICoBrowseDto;
  } = React.useContext(CoBrowseContext);
  const sessionType = coBrowseDto.session.type;
  const isOffer = sessionType === "Offering";
  const isActive = Boolean(sessionType) && !isOffer;
  const statusLabel = isOffer ? "anfrage" : isActive ? "aktiv" : "inaktiv";

  return (
    <Grid
      size={4}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
      }}
    >
      <Typography variant="body1" color="initial">
        Co-Browsing
      </Typography>

      <Box
        sx={{
          display: "flex",
          gap: "10px",
        }}
      >
        <Typography variant="caption" color="initial">
          Status:
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: isActive
              ? (theme) => theme.palette.success.main
              : isOffer
                ? (theme) => theme.palette.warning.main
                : (theme) => theme.palette.text.secondary,
            fontWeight: "bold",
          }}
        >
          {statusLabel}
        </Typography>
      </Box>
    </Grid>
  );
};

export default CoBrowseStatus;
